__turbopack_context__.v({
  "itemWrapper": "l8QlQq_itemWrapper" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "rightSlot": "l8QlQq_rightSlot",
  "supportingText": "l8QlQq_supportingText",
  "textCell": "l8QlQq_textCell",
});
